// libraries and utilities
import { put, call, takeEvery, select } from "redux-saga/effects";
import { ErrorResponse, ErrorResponseDetail } from "../../interfaces/ErrorResponse";
import { apiPut, apiUpload, BASE_URL, retrieveToken } from "../../store/api";
import { MonevUpdateResponse } from "./types";

import * as monevActions from "./monev.actions";
import { showModal } from "../modal/modal.actions";
import { RootState } from "../../store/rootReducer";
import { UploadFileResponse } from "../../interfaces/UploadFile";
import validateMonev from "./monev.saga.validation";

export function* updateMonev(
  action: ReturnType<typeof monevActions.updateMonevAsync.request>
) {
  try {
    const errors = validateMonev(action.payload);

    if (errors.data && errors.data.length > 0) {
      yield put(monevActions.createMonevAsync.failure(errors));
      return;
    }
    
    const token: string = yield retrieveToken();
    let payload = {...action.payload};

    // upload
    const fileState = (state: RootState) => state.monev.selectedFile;
    const file: File = yield select(fileState);

    if (file) {
      const filename = `${action.payload.DOK_ID}${file.name.trim().replace(/[^0-9a-z]/gi, '').toLowerCase()}`;
      const urlUpload = BASE_URL + `monev/upload`;

      const blob = new FormData();
      blob.append("filename", filename);
      blob.append("file", file);

      const resultUpload: Response = yield call(apiUpload, urlUpload, token, blob);

      if (resultUpload.status === 200 || resultUpload.status === 201) {
        const parsed: UploadFileResponse = yield call(resultUpload.json.bind(resultUpload));
        payload.FILE_KEGIATAN = parsed.data.fileName;
      } else {
        const parsed: ErrorResponse = yield call(resultUpload.json.bind(resultUpload));
        yield put(showModal(
          'Data gagal disimpan!',
          'Berkas yang Anda pilih tidak dapat diunggah. Mohon periksa ukuran, ekstensi, dan nama berkas.' + 
          '<ul>' +
          '<li>Berkas yang didukung hanyalah PDF dengan ukuran maksimum 10 MB.</li>' +
          '<li>Nama berkas hanya boleh terdiri dari huruf dan angka.</li>' +
          '</ul>'
        ));
        yield put(monevActions.updateMonevAsync.failure(parsed));
        return;
      }
    }

    // update
    const url = BASE_URL + `monev/${action.payload.MONEV_ID}`;
    const result: Response = yield call(apiPut, url, token, {
      ...payload,
      PENYELENGGARA: action.payload.PENYELENGGARA_DETAIL,
      PESERTA: action.payload.PESERTA_DETAIL,
      PESERTA_KEGIATAN: action.payload.PESERTA_KEGIATAN.replace(/\r?\n/g, '<br />')
    });

    if (result.status === 200) {
      const parsed: MonevUpdateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'))
      yield put(monevActions.getDokumenAsync.request({ DOK_ID: action.payload.DOK_ID }));
      yield put(monevActions.updateMonevAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      const errorMessage: ErrorResponseDetail[] = parsed.data ? parsed.data : [];
      if (parsed.status === 405) {
        yield put(showModal('Data gagal disimpan!', 'Anda tidak mempunyai akses untuk menyimpan data pada halaman ini. Mohon hubungi pihak terkait untuk meminta akses.'));  
      } else {
        yield put(showModal('Data gagal disimpan!', errorMessage[0].message));
      } 

      yield put(monevActions.updateMonevAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Data gagal disimpan!', 'Terjadi kesalahan pada server. Mohon coba kembali dalam beberapa saat.'));
    yield put(monevActions.updateMonevAsync.failure(parsed));
  }
}

export default function* monevSagaUpdateMonev() {
  yield takeEvery(monevActions.updateMonevAsync.request, updateMonev);
}
